function veda_fn_id_1728596905179_4fac0ed6ecea4eb3bbd1f2e08ac63417() {
    
    try {
      const uniqueId = /* _____Start/Id_____ */"id_1728596905179_4fac0ed6-ecea-4eb3-bbd1-f2e08ac63417"/* _____End/Id_____ */;
      const containers = document.querySelectorAll(`[data-id="${uniqueId}"]:not(addons, megamenu)`);
      containers.forEach(container => {
        if (!container) {
          return;
        }
        veda.plugins.videoCover(container);
        /* _____Start/Content_____ */
        function transformNumber(price) {
  const result = parseFloat(price.match(/\d+(\.\d+)?/)[0]);
  return result;
}

function calculateTotalSavings(reducedPrice, originalPrice, quantity) {
  const reducedPriceValue = parseFloat(reducedPrice.match(/\d+(\.\d+)?/)[0]);
  const originalPriceValue = parseFloat(originalPrice.match(/\d+(\.\d+)?/)[0]);
  const totalSavingsValue = (
    (originalPriceValue - reducedPriceValue) *
    quantity
  ).toFixed(2);
  const totalSavingsFormatted = reducedPrice.replace(
    /\d+(\.\d+)?/,
    totalSavingsValue
  );
  return totalSavingsFormatted;
}

function formatPrice(price, currencySymbol) {
  // Use toFixed(2) to round to two decimal places and convert to a string.
  return currencySymbol + (Math.round(price * 100) / 100).toFixed(2);
}

function calculateTotalPrice(price, quantity) {
  const _price = price.replace(",", "");
  const extractedPrice = parseFloat(_price.match(/\d+(\.\d+)?/)[0]);
  const currencySymbol = _price.match(/[^\d.,\s]+/)[0];
  const totalPrice = (extractedPrice * quantity).toFixed(2);
  const result = _price
    .replace(/\d+(\.\d+)?/, totalPrice)
    .replace(/[^\d.,\s]+/, currencySymbol);
  return result;
}

function roundDownNumber(num) {
  return Math.floor(num) + (num % 1 >= 0.5 ? 0.5 : 0);
}

function calculateDiscount({ type, discount, currentPrice }) {
  const _currentPrice = currentPrice.replace(",", "");
  const extractedPrice = parseFloat(_currentPrice.replace(/[^0-9.-]+/g, ""));
  const currencySymbol = _currentPrice.match(/[^\d.,\s]+/)[0];

  if (type === "percentage") {
    const totalPrice = roundDownNumber(extractedPrice * (100 - discount)) / 100;
    const result = _currentPrice
      .replace(/\d+(\.\d+)?/, totalPrice)
      .replace(/[^\d.,\s]+/, currencySymbol);
    return result;
  } else {
    const totalPrice = roundDownNumber(extractedPrice - discount);
    const result = _currentPrice
      .replace(/\d+(\.\d+)?/, totalPrice)
      .replace(/[^\d.,\s]+/, currencySymbol);
    return result;
  }
}

function updateQuantity(inputEle, quantity) {
  inputEle.value = quantity;
  inputEle.textContent = quantity;
}

const sectionContainer = builderMode
  ? document
  : container.closest(".veda-product-information-1") ||
    container.closest(".veda-product-information-2") ||
    container.closest(".veda-product-information-3") ||
    container.closest(".veda-product-information-4") ||
    container.closest(".veda-featured-product-1") ||
    container.closest(".veda-featured-product-2");

const sectionPriceEleWithSale = sectionContainer.querySelector(
  ".product-content-price-js"
);

const addonReducedPriceEles = container.querySelectorAll(".reduced-money-js");
const addonOriginalPriceEles = container.querySelectorAll(".original-money-js");
const radioButtons = Array.from(
  container.querySelectorAll('input[type="radio"][name="veda-bundle-option"]')
);

const containerDivs = container.querySelectorAll("div.veda-bundle-container");

const inputQuantity = (builderMode ? document : sectionContainer).querySelector(
  'input[name="quantity"][form="product-add-cart"]'
);

// Xử lý lắng nghe thay đổi variant củ product
const observer = new MutationObserver((mutations) => {
  mutations.forEach(() => {
    const notSalePriceEl = sectionPriceEleWithSale.querySelector(
      ".product-price-not-sale-js"
    );
    const saleEl = sectionPriceEleWithSale.querySelector(
      ".product-price-on-sale-js"
    );

    if (!!notSalePriceEl && !!saleEl) {
      let sectionOriginalPrice = sectionPriceEleWithSale.querySelector(
        ".product-price-on-sale-js del"
      );
      let sectionReducedPrice = sectionPriceEleWithSale.querySelector(
        ".product-price-on-sale-js ins"
      );

      const notSaleCondition =
        !notSalePriceEl.classList.contains("d:none") &&
        saleEl.classList.contains("d:none");

      if (notSaleCondition) {
        sectionReducedPrice = sectionPriceEleWithSale.querySelector(
          ".product-price-not-sale-js"
        );
        sectionOriginalPrice = sectionPriceEleWithSale.querySelector(
          ".product-price-not-sale-js"
        );
      } else {
        sectionReducedPrice = sectionPriceEleWithSale.querySelector(
          ".product-price-on-sale-js ins"
        );
        sectionOriginalPrice = sectionPriceEleWithSale.querySelector(
          ".product-price-on-sale-js ins"
        );
      }

      if (!!sectionReducedPrice) {
        addonReducedPriceEles.forEach((addonReducedPrice) => {
          const quantity = addonReducedPrice.getAttribute("data-quantity");
          const discountType =
            addonReducedPrice.getAttribute("data-discount-type");
          const discountValue = addonReducedPrice.getAttribute(
            "data-discount-value"
          );

          const _totalPrice = calculateTotalPrice(
            sectionReducedPrice.textContent,
            quantity
          );

          const priceDiscount = calculateDiscount({
            type: discountType,
            discount: Number(discountValue ?? 0),
            currentPrice: _totalPrice,
          });
          addonReducedPrice.textContent = priceDiscount;
        });
      }

      if (!!sectionOriginalPrice) {
        addonOriginalPriceEles.forEach((addonOriginalPrice) => {
          const quantity = addonOriginalPrice.getAttribute("data-quantity");

          if (
            transformNumber(addonOriginalPrice.textContent) !==
            transformNumber(sectionOriginalPrice.textContent)
          ) {
            addonOriginalPrice.classList.remove("d:none");
          } else {
            addonOriginalPrice.classList.add("d:none");
          }

          addonOriginalPrice.textContent = calculateTotalPrice(
            sectionOriginalPrice.textContent,
            quantity
          );
        });
      }
    }
  });
});

observer.observe(sectionPriceEleWithSale, {
  childList: true,
  attributes: true,
  subtree: true,
});

onCleanup(() => {
  observer.disconnect();
});

// Xử lý select radio
function updateDefaultInput(eles) {
  eles.forEach((radioButton) => {
    if (radioButton.checked) {
      radioButton.classList.add("bd:1px_solid_color-primary!");
      radioButton.classList.add("bxsh:inset_16px_16px_color-primary|be!");
      updateQuantity(inputQuantity, radioButton.value);
    }
  });
}

window.addEventListener("load", () => {
  updateDefaultInput(radioButtons);
});

const removeActiveClass = (eles) => {
  eles.forEach((ele) => {
    ele.classList.remove("bd:1px_solid_color-primary!");
    ele.classList.remove("bxsh:inset_16px_16px_color-primary|be!");
  });
};

function removeActiveClassFromAll(eles) {
  eles.forEach((containerDiv) => {
    const priceSale = containerDiv.querySelector(".price-on-sale");
    const priceNotSale = containerDiv.querySelector(".price-not-sale");
    priceSale.classList.remove("active");
    priceNotSale.classList.remove("active");
  });
}

radioButtons.forEach((radioButton) => {
  radioButton.addEventListener("change", () => {
    if (!!inputQuantity) {
      updateQuantity(inputQuantity, radioButton.value);
    }
  });
});

containerDivs.forEach((containerDiv) => {
  const radioButton = containerDiv.querySelector(
    'input[type="radio"][name="veda-bundle-option"]'
  );
  const priceSale = containerDiv.querySelector(".price-on-sale");
  const priceNotSale = containerDiv.querySelector(".price-not-sale");

  if (radioButton.checked) {
    radioButton.classList.add("bd:1px_solid_color-primary!");
    radioButton.classList.add("bxsh:inset_16px_16px_color-primary|be!");
    priceSale.classList.add("active");
    priceNotSale.classList.add("active");
  }

  containerDiv.addEventListener("click", () => {
    const radioButton = containerDiv.querySelector(
      'input[type="radio"][name="veda-bundle-option"]'
    );
    removeActiveClass(radioButtons);
    removeActiveClassFromAll(containerDivs);
    radioButton.checked = true;
    radioButton.classList.add("bd:1px_solid_color-primary!");
    radioButton.classList.add("bxsh:inset_16px_16px_color-primary|be!");
    priceSale.classList.add("active");
    priceNotSale.classList.add("active");

    if (!!inputQuantity) {
      updateQuantity(inputQuantity, radioButton.value);
    }
  });
});

        /* _____End/Content_____ */
      });
    } catch (error) {
      console.log(error);
    }
  };
veda_fn_id_1728596905179_4fac0ed6ecea4eb3bbd1f2e08ac63417();
